import { render, staticRenderFns } from "./ModalConfiguracoesWhatsappOficial.vue?vue&type=template&id=5d303cf2&"
import script from "./ModalConfiguracoesWhatsappOficial.vue?vue&type=script&lang=js&"
export * from "./ModalConfiguracoesWhatsappOficial.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfiguracoesWhatsappOficial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports